export default __webpack_public_path__ + "static/media/facebook.cd9e4d03.svg";